const PRODUCTION_API_URL = 'https://api.realitni-jestrab.cz'
const configuredApiUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '')
const configuredLocalhost = configuredApiUrl && /^https?:\/\/(localhost|127\.0\.0\.1)(?::|$)/i.test(configuredApiUrl)

export const API_BASE_URL =
  process.env.NODE_ENV === 'production' && configuredLocalhost
    ? PRODUCTION_API_URL
    : configuredApiUrl || PRODUCTION_API_URL
